import { useCallback } from 'react'
import { useQuery } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { defaultStaleTime } from '../../../config/queryClient'
import { QueryKeys } from '../../../enums/queryKeys'
import { BankAccountsResponse, fetchBankAccounts } from '../query-api'

interface UseFetchBankAccountsOptions {
  enabled?: boolean
}

export const useFetchBankAccounts = ({ enabled = true }: UseFetchBankAccountsOptions = {}) => {
  const { organization } = useUserOrganization()

  const convertBalancesToMajorUnits = useCallback((response: BankAccountsResponse): BankAccountsResponse => {
    return {
      data: response.data.map((account) => ({
        ...account,
        bookedBalance: account.bookedBalance && {
          value: account.bookedBalance.value / 100,
          currency: account.bookedBalance.currency,
        },
        availableBalance: account.availableBalance && {
          value: account.availableBalance.value / 100,
          currency: account.availableBalance.currency,
        },
      })),
    }
  }, [])

  const { data, isError, isLoading } = useQuery(
    [QueryKeys.BankAccounts],
    () => fetchBankAccounts(organization?.id || ''),
    {
      enabled: !!organization?.id && enabled,
      select: convertBalancesToMajorUnits,
      staleTime: defaultStaleTime,
    },
  )

  return {
    bankAccounts: data?.data || [],
    isError,
    isLoading,
  }
}
